import { CustomerContactDetail } from 'generated-api/bff/api';

export const mapContactDetails = (contactDetails: CustomerContactDetail[]): Record<string, string> => {
	return Object.fromEntries(contactDetails.map(({ type, detail }) => [type, detail ?? '']));
};

export const formatAddress = (detailMap: Record<string, string>): string => {
	const street = [detailMap['Street__c'], detailMap['Street_Number__c']].filter(Boolean).join(' ');
	const floor = detailMap['Floor__c'] ? detailMap['Floor__c'] + '.' : '';
	const apartment = [floor, detailMap['Floor_Door__c'], detailMap['Street_Letter__c']].filter(Boolean).join(' ');
	const city = [detailMap['Postal_Code__c'], detailMap['City__c']].filter(Boolean).join(' ');
	return [street, apartment, city].filter(Boolean).join(', ');
};
